const sessionStore = {
	read: (key: string): string | null => {
		try {
			return sessionStorage.getItem(key);
		} catch {
			return null;
		}
	},
	write: (key: string, value: string): void => {
		try {
			sessionStorage.setItem(key, value);
		} catch {
			return;
		}
	}
};

export default sessionStore;
